export default "__VITE_ASSET__c2eb9052__"